import { rem } from 'polished';

const theme = {
  colors: {
    hyperlink: '#0058A3',
    text: '#111111',
    yellow: '#FFDB00',
    indicator: {
      default: '#0058A3',
      hover: '#8eaec1'
    },
    feedback: {
      focus: '#111111',
      information: '#0058A3',
      selected: '#007CC8',
      error: '#e0075E'
    },
    semantic: {
      positive: '#0A8A00',
      caution: '#F26a2F',
      negative: '#E0075E'
    },
    transparent: 'transparent',
    grey: {
      /** #F5F5F7  */
      modal: '#F5F5F7',
      /** #F5F5F5 */
      100: '#F5F5F5',
      /** #DFDFDF */
      200: '#DFDFDF',
      /** #CCCCCC */
      300: '#CCCCCC',
      /** #959595 */
      500: '#959595',
      /** #666666 */
      700: '#666666',
      /** #333333 */
      800: '#333333',
      /** #111111 */
      900: '#111111'
    },
    white: '#FFFFFF'
  },
  space: {
    /** 2px - 0.125rem*/
    xxxs: rem('2px'),
    /** 4px - 0.25rem*/
    xxs: rem('4px'),
    /** 8px - 0.5rem*/
    xs: rem('8px'),
    /** 12px - 0.75rem*/
    s: rem('12px'),
    /** 16px - 1rem */
    md: rem('16px'),
    /** 20px - 1.25rem*/
    mdl: rem('20px'),
    /** 24px - 1.5rem*/
    l: rem('24px'),
    /** 32px - 2rem*/
    xl: rem('32px'),
    /** 48px - 3rem*/
    xxl: rem('48px'),
    /** 56px - 3.5rem*/
    xxxl: rem('56px'),
    /** 64px - 4rem*/
    xxxxl: rem('64px'),
    /** 64px - 4.5rem*/
    xxxxxl: rem('72px')
  },
  lineHeights: {
    normal: 'normal',
    none: '1',
    narrow: '1.125',
    shorter: '1.25',
    short: '1.375',
    base: '1.5',
    tall: '1.625'
  },
  layout: {
    tabsWidth: '17.5rem',
    headerHeight: '6rem',
    mobileHeaderHeight: '4rem',
    sidebarWidth: '30rem', // 480px
    mobileProductGroupMenuHeight: '14rem', // 224px
    mobileMenuHeight: '8.75rem' // 140px
  },
  boxShadow: {
    elevated: '0 4px 16px rgba(0, 0, 0, 0.1)'
  },
  zIndex: {
    print: 10000,
    sheet: 501 //Skapa default z-index is 400 and Kompis sheets have a z-index of 500, we put it at 501 to be on top of Kompis hamburger menu
  }
} as const;

export type ThemeType = typeof theme;

export default theme;
